<template>
  <div>
    <!-- Header -->
    <div class="d-flex align-items-center justify-content-between mb-2">
      <div class="d-flex align-items-center" style="gap: 12px">
        <b-button variant="outline-primary" size="sm" @click="$router.back()">
          <feather-icon icon="ArrowLeftIcon" class="mr-50" />
          Back to Template Management
        </b-button>
        <span class="text-muted">
          Showing templates for: <strong>{{ activeProfile }}</strong>
        </span>
      </div>
      <div class="d-flex align-items-center" style="gap: 8px">
        <b-form-input
          v-model="search"
          placeholder="Search templates..."
          size="sm"
          style="width: 200px"
        >
          <template #prepend>
            <feather-icon icon="SearchIcon" />
          </template>
        </b-form-input>
        <b-button variant="primary" size="sm" @click="goToCreate">
          <feather-icon icon="PlusIcon" class="mr-50" />
          Add Template
        </b-button>
      </div>
    </div>

    <!-- Stats -->
    <b-row class="mb-2">
      <b-col md="3" v-for="stat in stats" :key="stat.label">
        <b-card class="text-center mb-1" body-class="py-1">
          <h3 class="font-weight-bolder mb-0" :class="stat.color">{{ stat.value }}</h3>
          <small class="text-muted">{{ stat.label }}</small>
        </b-card>
      </b-col>
    </b-row>

    <!-- Table -->
    <b-card no-body>
      <b-card-header>
        <div>
          <h5 class="mb-0">Template List</h5>
          <small class="text-muted">Templates assigned to profile {{ activeProfile }}</small>
        </div>
      </b-card-header>
      <b-table
        :items="filteredTemplates"
        :fields="fields"
        :busy="loading"
        show-empty
        responsive
        class="mb-0"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner small class="mr-1" />
            Loading...
          </div>
        </template>
        <template #empty>
          <div class="text-center text-muted my-2">No templates found.</div>
        </template>
        <template #cell(templateUsed)="{ item }">
          <div>
            <strong>{{ item.name }}</strong>
            <div><small class="text-muted">Base: {{ activeProfile }}</small></div>
          </div>
        </template>
        <template #cell(actions)="{ item }">
          <div class="d-flex" style="gap: 4px">
            <b-button size="sm" variant="outline-primary" class="btn-icon p-50" @click="onEdit(item)">
              <feather-icon icon="Edit2Icon" size="14" />
            </b-button>
            <b-button size="sm" variant="outline-danger" class="btn-icon p-50" disabled>
              <feather-icon icon="Trash2Icon" size="14" />
            </b-button>
          </div>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BTable,
  BButton,
  BFormInput,
  BSpinner,
} from "bootstrap-vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "TemplateList",
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BTable,
    BButton,
    BFormInput,
    BSpinner,
  },
  data() {
    return {
      loading: false,
      search: "",
      templates: [],
      fields: [
        { key: "templateUsed", label: "Template Used" },
        { key: "actions", label: "Actions" },
      ],
    };
  },
  computed: {
    ...mapState({ _activeProfile: (state) => state.bettingConfig.list.activeProfile }),
    activeProfile() {
      return this.$route.query.profile || this._activeProfile;
    },
    filteredTemplates() {
      if (!this.search.trim()) return this.templates;
      const q = this.search.toLowerCase();
      return this.templates.filter((t) => t.name.toLowerCase().includes(q));
    },
    stats() {
      return [
        { label: "Total Templates", value: this.templates.length, color: "text-primary" },
        { label: "Active Templates", value: this.templates.length, color: "text-success" },
        { label: "Under Review", value: 0, color: "text-warning" },
        { label: "Unique Variants", value: this.templates.length, color: "text-info" },
      ];
    },
  },
  async created() {
    await this.fetchTemplates();
  },
  methods: {
    ...mapActions({ getBettingTemplates: "user/detail/getBettingTemplates" }),
    async fetchTemplates() {
      this.loading = true;
      try {
        const data = await this.getBettingTemplates(this.activeProfile);
        this.templates = (data || []).map((name) => ({ name }));
      } finally {
        this.loading = false;
      }
    },
    onEdit(item) {
      const profile = this.activeProfile || "";
      const prefix = profile + "-";
      const nameSuffix = item.name.startsWith(prefix)
        ? item.name.slice(prefix.length)
        : item.name;
      this.$router.push({
        name: "settings-create-betting-template",
        query: { baseTemplate: profile, name: nameSuffix, profileTypeId: item.name },
      });
    },
    goToCreate() {
      this.$router.push({
        name: "settings-create-betting-template",
        query: { baseTemplate: this.activeProfile },
      });
    },
  },
};
</script>
